define('lq/services/mpa/applicationValidation',[],function () {
    'use strict';

    var shortCutKey = 27; // Escape
    var delta = 500;
    var numberToTrigger = 3;

    function ApplicationValidation(annotations) {
        this.annotations = annotations;
        this.presses = 0;
    };

    ApplicationValidation.typeName = 'ApplicationValidation';

    ApplicationValidation.prototype.initialize = function () {
        if (this.annotations.isProductionModeEnabled) {
            this.handler = this.handleKeyUp.bind(this);
            $(document).on('keyup',  this.handler);
        } else {
            this.startValidation();
        }
    };

    ApplicationValidation.prototype.start = function (LicquidRuntimeValidation) {
        var validation = new LicquidRuntimeValidation();
        validation.start(this.rootDrop, this.annotations);
    };

    ApplicationValidation.prototype.handleKeyUp = function (event) {
        if (event.keyCode !== shortCutKey)
            return;

        var keyPressTime = new Date();

        if (this.previousKeyPressTime && keyPressTime - this.previousKeyPressTime > delta) {
            this.presses = 1;
            this.previousKeyPressTime = keyPressTime;
        } else if (this.presses === numberToTrigger - 1) {
            this.presses = 0;
            this.previousKeyPressTime = null;
            this.startValidation();
            $(document).off('keyup', this.handler);
        } else {
            this.presses++;
            this.previousKeyPressTime = keyPressTime;
        }
    };

    ApplicationValidation.prototype.startValidation = function () {
        require([
            'lq/licquidRuntimeValidation'
        ], this.start.bind(this));
    };

    return ApplicationValidation;
});

